export default "__VITE_ASSET__C0r5DF19__"